import getCallResult from '../API/CallResult';

export default class ProxyLogger {
    constructor(sdkLogger) {
        this.sdkLogger = sdkLogger;
    }
    log(data) {
        return new Promise((resolve) => {
            this.sdkLogger.log('DC', data)
                .then(() => resolve(getCallResult()))
                .catch(() => resolve(getCallResult({ succeeded: false })));
        });
    }
}